module.exports = __webpack_public_path__ + "img/15.25517b84.jpg";